//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Button } from 'vant';
import wx from 'weixin-js-sdk';

export default {
  name: 'index',
  props: ['params'],
  metaInfo: {
    title: '支付成功'
  },
  created: async function () {
    wx.miniProgram.getEnv((res) => {
      this.isWxapp = res.miniprogram;
    });
    const interval = setInterval(() => {
      this.time--;
      if (this.time == 0) {
        clearInterval(interval);
        this.handleSuccess();
      }
    }, 1000);
  },
  data() {
    return {
      time: 5
    };
  },
  computed: {},
  filters: {},
  components: {
    'van-button': Button
  },
  methods: {
    handleSuccess() {
      if (this.isWxapp) {
        wx.miniProgram.postMessage({
          data: {
            type: 'success'
          }
        });
        wx.miniProgram.navigateBack();
      } else {
        window.postMessage(JSON.stringify({
          type: 'success'
        }));
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/module/app/paySuccess/page.vue